export default "<div ui-view></div>\n"